//
// Manages floating ads.
function AdsNinjaFloatingManager(logger, bannerStrategy, videoStrategy){

    if(!logger || !bannerStrategy || !videoStrategy){

        throw new Error('One or more parameters are missing.');
    }

    this.__logger                    = logger;
    this.__bannerStrategy            = bannerStrategy;
    this.__videoStrategy             = videoStrategy;
    this.__state                     = {};
    this.__positionMapping           = {};
    this.__adTypeMapping             = {};
    this.__floatAdTypeRequestQueue   = {};
    this.__floatPositionRequestQueue = {};
    this.__disabledElements          = [];

    for(var adType in AdsNinjaFloatingManager.prototype.SUPPORTED_AD_TYPES){
        
        this.__adTypeMapping[adType]           = [];
        this.__floatAdTypeRequestQueue[adType] = [];
    }

    for(var position in AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS){

        this.__positionMapping[position]           = [];
        this.__floatPositionRequestQueue[position] = [];
    }
}

// Constants.
AdsNinjaFloatingManager.prototype.AD_TYPE_BANNER                                                                  = 'banner';
AdsNinjaFloatingManager.prototype.AD_TYPE_VIDEO                                                                   = 'video';
AdsNinjaFloatingManager.prototype.FLOAT_TYPE_ALWAYS                                                               = 'always';
AdsNinjaFloatingManager.prototype.FLOAT_TYPE_OUT_OF_VIEW                                                          = 'outOfView';
AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_LEFT                                                            = 'bottom-left';
AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_MIDDLE                                                          = 'bottom-middle';
AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_RIGHT                                                           = 'bottom-right';
AdsNinjaFloatingManager.prototype.POSITION_TOP_LEFT                                                               = 'top-left';
AdsNinjaFloatingManager.prototype.POSITION_TOP_MIDDLE                                                             = 'top-middle';
AdsNinjaFloatingManager.prototype.POSITION_TOP_RIGHT                                                              = 'top-right';
AdsNinjaFloatingManager.prototype.POSITION_CENTER_LEFT                                                            = 'center-left';
AdsNinjaFloatingManager.prototype.POSITION_CENTER_MIDDLE                                                          = 'center-middle';
AdsNinjaFloatingManager.prototype.POSITION_CENTER_RIGHT                                                           = 'center-right';
AdsNinjaFloatingManager.prototype.REQUESTOR_USER                                                                  = 'user';
AdsNinjaFloatingManager.prototype.REQUESTOR_MANAGER                                                               = 'manager';
AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND                                                                 = 'suspend';
AdsNinjaFloatingManager.prototype.CONTEXT_RESUME                                                                  = 'resume';
AdsNinjaFloatingManager.prototype.CONTEXT_NONE                                                                    = 'none';
AdsNinjaFloatingManager.prototype.SUPPORTED_AD_TYPES                                                              = {};  
AdsNinjaFloatingManager.prototype.SUPPORTED_AD_TYPES[AdsNinjaFloatingManager.prototype.AD_TYPE_BANNER]            = AdsNinjaFloatingManager.prototype.AD_TYPE_BANNER;
AdsNinjaFloatingManager.prototype.SUPPORTED_AD_TYPES[AdsNinjaFloatingManager.prototype.AD_TYPE_VIDEO]             = AdsNinjaFloatingManager.prototype.AD_TYPE_VIDEO;
AdsNinjaFloatingManager.prototype.SUPPORTED_FLOAT_TYPES                                                           = {};
AdsNinjaFloatingManager.prototype.SUPPORTED_FLOAT_TYPES[AdsNinjaFloatingManager.prototype.FLOAT_TYPE_ALWAYS]      = AdsNinjaFloatingManager.prototype.FLOAT_TYPE_ALWAYS;
AdsNinjaFloatingManager.prototype.SUPPORTED_FLOAT_TYPES[AdsNinjaFloatingManager.prototype.FLOAT_TYPE_OUT_OF_VIEW] = AdsNinjaFloatingManager.prototype.FLOAT_TYPE_OUT_OF_VIEW;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS                                                             = {};
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_LEFT]     = AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_LEFT;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_MIDDLE]   = AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_MIDDLE;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_RIGHT]    = AdsNinjaFloatingManager.prototype.POSITION_BOTTOM_RIGHT;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_TOP_LEFT]        = AdsNinjaFloatingManager.prototype.POSITION_TOP_LEFT;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_TOP_MIDDLE]      = AdsNinjaFloatingManager.prototype.POSITION_TOP_MIDDLE;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_TOP_RIGHT]       = AdsNinjaFloatingManager.prototype.POSITION_TOP_RIGHT;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_CENTER_LEFT]     = AdsNinjaFloatingManager.prototype.POSITION_CENTER_LEFT;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_CENTER_MIDDLE]   = AdsNinjaFloatingManager.prototype.POSITION_CENTER_MIDDLE;
AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS[AdsNinjaFloatingManager.prototype.POSITION_CENTER_RIGHT]    = AdsNinjaFloatingManager.prototype.POSITION_CENTER_RIGHT;

//
// Request to float.
AdsNinjaFloatingManager.prototype.requestToFloat = function(elementId, requestor, adType, position, floatType, floatCallback, defloatCallback){

    this.__logger.debug('Requesting to float.');

    var requestDetails = this.__createRequestDetails(elementId, requestor, adType, position, floatType, floatCallback, defloatCallback);

    if(!this.__validateFloatRequestDetails(requestDetails)){

        this.__logger.warn('Float request failed. One or more parameters are missing or invalid.', requestDetails);

        return false;
    }

    if(this.__isAdFloating(elementId)){

        // TODO: Reduce log level.
        this.__logger.warn('Float request rejected. Ad is already floating.', requestDetails);

        return false;
    }
    else if(!this.__isAllowedToFloat(elementId)){

        // TODO: Reduce log level.
        this.__logger.warn('Float request rejected. Ad is not allowed to float.', requestDetails);

        return false;
    }

    var strategy = this.__getStrategyByAdType(requestDetails['adType']);
    var result   = strategy.handleRequestToFloat(
        requestDetails, 
        this.__adTypeMapping, 
        this.__floatAdTypeRequestQueue,
        this.__positionMapping, 
        this.__floatPositionRequestQueue, 
        this.__state,
        this.__disabledElements
    );

    // Update state.
    this.__updateState(result);

    return result.requestApproved || false;
};

//
// Notify of defloat.
AdsNinjaFloatingManager.prototype.requestToDefloat = function(elementId, requestor, disableFloat = false){

    this.__logger.debug('Requesting of defloat.');

    var originalAdElementId = this.getOriginalElementId(elementId);

    if(!originalAdElementId){

        this.__logger.warn('Defloat request rejected. Missing original ad element ID.', {
            elementId: elementId,
            requestor: requestor,
        });

        return false;
    }

    var currentInfo = this.__state[originalAdElementId];

    if(!currentInfo){

        // TODO: Reduce log level.
        this.__logger.warn('Defloat request rejected. Ad is not floating.', {
            elementId: elementId,
            requestor: requestor,
        });    

        return false;
    }

    var requestDetails = this.__createRequestDetails(
        elementId, 
        requestor, 
        currentInfo.adType, 
        currentInfo.position, 
        currentInfo.floatType, 
        currentInfo.floatCallback, 
        currentInfo.defloatCallback,
        (disableFloat) ? AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND : AdsNinjaFloatingManager.prototype.CONTEXT_NONE
    );

    if(!this.__validateDefloatRequestDetails(requestDetails)){

        this.__logger.warn('Defloat request failed. One or more parameters are missing or invalid.', requestDetails);

        return false;
    }

    if(!this.__isAdFloating(elementId)){

        // TODO: Reduce log level.
        this.__logger.warn('Defloat request rejected. Ad is not floating.', requestDetails);

        // TODO: Remove from queue.
        this.__removeFromfloatPositionRequestQueue(elementId, currentInfo.position);

        return false;
    }

    // var currentInfo = this.__state[elementId];

    // if(currentInfo.position !== position){

    //     this.__logger.warn('Element is floating at a different position than requested.', );
    // }

    var strategy = this.__getStrategyByAdType(requestDetails['adType']);
    var result   = strategy.handleRequestToDefloat(
        requestDetails, 
        this.__adTypeMapping, 
        this.__floatAdTypeRequestQueue,
        this.__positionMapping, 
        this.__floatPositionRequestQueue, 
        this.__state,
        this.__disabledElements
    );

    // Update state.
    this.__updateState(result);

    if(disableFloat){

        this.disableElement(elementId, requestor, currentInfo.adType, currentInfo.position, currentInfo.floatType);
    }

    if(!result.requestApproved){

        return false;
    }

    return true;
};

//
// Check if element is floating.
AdsNinjaFloatingManager.prototype.__isAdFloating = function(elementId){

    return (this.__state && this.__state.hasOwnProperty(this.getOriginalElementId(elementId)));
};

//
// Check if element is allowed to float.
// TODO: This is a hack should be refactored later.
AdsNinjaFloatingManager.prototype.__isAllowedToFloat = function(elementId){
    
    return window.adsNinjaHeaderBiddingManager.isAllowedToFloat(elementId);
};

//
// Update state.
AdsNinjaFloatingManager.prototype.__updateState = function(result){

    // Validate result.
    if(!result 
        || typeof result !== 'object' 
        || Object.keys(result).length === 0 
        || !result.hasOwnProperty('state')
        || typeof result.state !== 'object'
        || !result.hasOwnProperty('adTypeMapping')
        || typeof result.adTypeMapping !== 'object'
        || !result.hasOwnProperty('positionMapping')
        || typeof result.positionMapping !== 'object'
        || !result.hasOwnProperty('floatAdTypeRequestQueue')
        || typeof result.floatAdTypeRequestQueue !== 'object'
        || !result.hasOwnProperty('floatPositionRequestQueue')
        || typeof result.floatPositionRequestQueue !== 'object'
        || !result.hasOwnProperty('disabledElements')
        || typeof result.disabledElements !== 'object'
    ){
        
        throw new Error('Invalid result from strategy.');
    }

    this.__adTypeMapping             = result.adTypeMapping;
    this.__floatAdTypeRequestQueue   = result.floatAdTypeRequestQueue;
    this.__positionMapping           = result.positionMapping;
    this.__floatPositionRequestQueue = result.floatPositionRequestQueue;
    this.__state                     = result.state;
    this.__disabledElements          = result.disabledElements;
};

//
// Returns request details.
AdsNinjaFloatingManager.prototype.__createRequestDetails = function(elementId, requestor, adType, position, floatType, floatCallback, defloatCallback, context = AdsNinjaFloatingManager.prototype.CONTEXT_NONE){

    var result = {
        elementId: elementId,
        originalElementId: this.getOriginalElementId(elementId),
        requestor: requestor,
        adType: adType,
        position: position,
        floatType: floatType,
        context: context,
        floatCallback: floatCallback,
        defloatCallback: defloatCallback,
    };

    return result;
};

//
// Validate request details.
AdsNinjaFloatingManager.prototype.__validateRequestDetails = function(context, requestDetails){

    if(!requestDetails
        || typeof requestDetails !== 'object'
        || Object.keys(requestDetails).length === 0
        || !requestDetails.hasOwnProperty('elementId')
        || typeof requestDetails.elementId !== 'string'
        || !requestDetails.elementId
        || !requestDetails.hasOwnProperty('requestor')
        || typeof requestDetails.requestor !== 'string'
        || !requestDetails.requestor
    ){
        
        return false;
    }

    if(context === 'float' && (
        !requestDetails.hasOwnProperty('adType')
        || typeof requestDetails.adType !== 'string'
        || !requestDetails.adType
        || !AdsNinjaFloatingManager.prototype.SUPPORTED_AD_TYPES.hasOwnProperty(requestDetails.adType)
        || !requestDetails.hasOwnProperty('position')
        || typeof requestDetails.position !== 'string'
        || !requestDetails.position
        || !AdsNinjaFloatingManager.prototype.SUPPORTED_POSITIONS.hasOwnProperty(requestDetails.position)
        || !requestDetails.hasOwnProperty('floatType')
        || typeof requestDetails.floatType !== 'string'
        || !requestDetails.floatType
        || !AdsNinjaFloatingManager.prototype.SUPPORTED_FLOAT_TYPES.hasOwnProperty(requestDetails.floatType)
        || !requestDetails.hasOwnProperty('floatCallback')
        || typeof requestDetails.floatCallback !== 'function'
        || !requestDetails.hasOwnProperty('defloatCallback')
        || typeof requestDetails.defloatCallback !== 'function'
    )){

        return false;
    }

    return true;
};

//
// Validate float request details.
AdsNinjaFloatingManager.prototype.__validateFloatRequestDetails = function(requestDetails){

    return this.__validateRequestDetails('float', requestDetails);
};

//
// Validate defloat request details.
AdsNinjaFloatingManager.prototype.__validateDefloatRequestDetails = function(requestDetails){

    return this.__validateRequestDetails('defloat', requestDetails);
};

//
// Remove from floating queue.
// TODO: Delegate to strategy.
AdsNinjaFloatingManager.prototype.__removeFromfloatPositionRequestQueue = function(elementId, position){
    
    var originalElementId = this.getOriginalElementId(elementId);
    var index             = this.floatPositionRequestQueue[position].findIndex(function(entry){

        return (entry.originalElementId === originalElementId);
    });

    if(index > -1){

        this.floatPositionRequestQueue[position].splice(index, 1);
    }
};

//
// Get strategy by ad type.
AdsNinjaFloatingManager.prototype.__getStrategyByAdType = function(adType){

    if(adType === AdsNinjaFloatingManager.prototype.AD_TYPE_BANNER){

        return this.__bannerStrategy;
    }

    return this.__videoStrategy;
};

//
// Enable element.
AdsNinjaFloatingManager.prototype.enableElement = function(elementId, requestor, adType, position, floatType){

    var requestDetails = this.__createRequestDetails(elementId, requestor, adType, position, floatType, function(){}, function(){}, AdsNinjaFloatingManager.prototype.CONTEXT_RESUME);

    var strategy = this.__getStrategyByAdType(adType);
    var result   = strategy.handleEnableElement(
        requestDetails,
        this.__adTypeMapping, 
        this.__floatAdTypeRequestQueue,
        this.__positionMapping, 
        this.__floatPositionRequestQueue, 
        this.__state,
        this.__disabledElements
    );

    requestDetails                   = result.requestDetails;
    this.__adTypeMapping             = result.adTypeMapping;
    this.__floatAdTypeRequestQueue   = result.floatAdTypeRequestQueue;
    this.__positionMapping           = result.positionMapping;
    this.__floatPositionRequestQueue = result.floatPositionRequestQueue;
    this.__state                     = result.state;
    this.__disabledElements          = result.disabledElements;
};

//
// Disable element.
AdsNinjaFloatingManager.prototype.disableElement = function(elementId, requestor, adType, position, floatType){

    var requestDetails = this.__createRequestDetails(elementId, requestor, adType, position, floatType, function(){}, function(){}, AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND);

    var strategy = this.__getStrategyByAdType(adType);
    var result   = strategy.handleDisableElement(
        requestDetails,
        this.__adTypeMapping, 
        this.__floatAdTypeRequestQueue,
        this.__positionMapping, 
        this.__floatPositionRequestQueue, 
        this.__state,
        this.__disabledElements
    );

    requestDetails                   = result.requestDetails;
    this.__adTypeMapping             = result.adTypeMapping;
    this.__floatAdTypeRequestQueue   = result.floatAdTypeRequestQueue;
    this.__positionMapping           = result.positionMapping;
    this.__floatPositionRequestQueue = result.floatPositionRequestQueue;
    this.__state                     = result.state;
    this.__disabledElements          = result.disabledElements;
};

/**
 * Get original element id.
 * 
 * @param {string} elementId 
 * @returns 
 */
AdsNinjaFloatingManager.prototype.getOriginalElementId = function(elementId){

    var zone = window.adsNinja.zoneDelegate.getByElementId(elementId);

    return (zone) ? zone.getOriginalUnitElementId() : elementId;
};

window.AdsNinjaFloatingManager = AdsNinjaFloatingManager;